import * as en from './languages/en.json';
import * as es from './languages/es.json';

function formatUnicorn(str, args) {
    let key;
    for (key in args) {
        str = str.replace(new RegExp('\\{' + key + '\\}', 'gi'), args[key]);
    }

    return str;
}
function toTitleCase(str) {
    return str.replace(/\w\S*/g, function(txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
}

const languageMap = {
    en,
    es
};

export const capitalization = {
    default: undefined,
    all: 'all',
    eachWord: 'eachWord',
    first: 'first'
};

const languageIdEnum = ['en', 'es'];

let language = languageMap[`en`];

export const setLanguage = langId => {
    if (!languageMap[languageIdEnum[langId]]) {
        throw new Error(`Language ${langId} ${languageIdEnum[langId]} not supported`);
    }
    language = languageMap[languageIdEnum[langId]];
};

export const copyFor = (
    category,
    type,
    actionType = undefined,
    caps = undefined,
    formattingArgs = undefined
) => {
    let val;
    if (actionType && language[actionType]) {
        val = (language[actionType][category] || {})[type];
    }
    if (!val) {
        val = (language[`general`][category] || {})[type];
    }
    if (!val) {
        console.error(`Copy not found for ${category} ${type} ${actionType}`);
        throw new Error(`Copy not found for ${category} ${type} ${actionType}`);
    }
    if (formattingArgs) {
        val = formatUnicorn(val, formattingArgs);
    }
    if (caps === capitalization.all) {
        return val.toUpperCase();
    }
    if (caps === capitalization.eachWord) {
        return toTitleCase(val);
    }
    if (caps === capitalization.first) {
        return val.charAt(0).toUpperCase() + val.substr(1);
    }
    return val;
};



// WEBPACK FOOTER //
// ./src/copy/copy.js